export default "__VITE_ASSET__4bb63e26__"